import React from 'react'
import Pt from 'prop-types'
import RealSteps from 'rc-steps'

import BillingGroupName from 'internal-components/src/components/Client/BillingGroupName'
import { SignupWithExternalsRecord } from 'internal-components/src/records'
import 'rc-steps/assets/index.css'

import { SignupProgressRecord } from '../../../records/SignupProgress'

import Step from './Step'

export default function Steps({
  dimensions,
  signupProgress,
  signupWithExternals,
}) {
  const signup = signupWithExternals.signup

  let serviceDescription = 'Additional Service Information'
  if (signupProgress.page === 'summary') {
    if (signup.hasIn(['data', 'auth.username'])) {
      serviceDescription = signup.getIn(['data', 'auth.username'])

      if (signup.hasIn(['data', 'auth.realm'])) {
        serviceDescription += '@'
        serviceDescription += signup.getIn(['data', 'auth.realm'])
      }
    } else if (signup.hasIn(['data', 'hostname'])) {
      serviceDescription = signup.getIn(['data', 'hostname'])
    }
  }

  let businessName = 'Personal Account and Business Details'
  if (signupWithExternals.client && signupWithExternals.billingGroup) {
    businessName = (
      <BillingGroupName
        billingGroup={signupWithExternals.billingGroup}
        client={signupWithExternals.client}
      />
    )
  } else if (signupWithExternals.client) {
    businessName = `${signupWithExternals.client.name} - ${signup.companyName}`
  } else if (
    signupProgress.page !== 'account' &&
    signupProgress.page !== 'offer'
  ) {
    businessName = signup.companyName || (signup.firstName + ' ' + signup.lastName)
  }

  return (
    <RealSteps
      direction={
        dimensions && dimensions.innerWidth <= 800 ? 'vertical' : 'horizontal'
      }
      current={null}
    >
      <Step
        completed={signupProgress.addressCompleted}
        description={signup.address || 'No address selected'}
        error={signupProgress.addressError}
        iconName="check"
        id="signup-step-address"
        linkTo={signupProgress.canAdvanceToAddress && '/'}
        title="Address"
      />
      <Step
        completed={signupProgress.offerCompleted}
        description={
          signupWithExternals.offer
            ? signupWithExternals.offer.name
            : 'Product and Plan Selection'
        }
        error={signupProgress.offerError}
        iconName="server"
        id="signup-step-offer"
        linkTo={signupProgress.canAdvanceToOffer && '/offer'}
        title="Plan"
      />
      <Step
        completed={signupProgress.accountCompleted}
        description={businessName}
        error={signupProgress.accountError}
        iconName="user"
        id="signup-step-account"
        linkTo={signupProgress.canAdvanceToAccount && '/account'}
        title="Account"
      />
      <Step
        completed={signupProgress.detailCompleted}
        description={serviceDescription}
        error={signupProgress.detailError}
        iconName="cloud"
        id="signup-step-detail"
        linkTo={signupProgress.canAdvanceToDetail && '/detail'}
        title="Service"
      />
      <Step
        completed={signupProgress.summaryCompleted}
        description="Payment and Submission"
        error={signupProgress.summaryError}
        iconName="credit-card-alt"
        id="signup-step-summary"
        linkTo={signupProgress.canAdvanceToSummary && '/summary'}
        title="Finalise"
      />
    </RealSteps>
  )
}

Steps.propTypes = {
  dimensions: Pt.shape({
    innerWidth: Pt.number.isRequired,
  }),
  signupProgress: Pt.instanceOf(SignupProgressRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ProgressSummary/Steps.jsx